import $ from 'jquery';

export default {
    floatingLabel() {

        $(document).on('focusin', 'input[type="text"], input[type="email"], input[type="number"], input[type="date"], input[type="password"], input[type="tel"]', event => {
            if ('component' in event.target.dataset) {
                return;
            }
            if ($(event.target.parentElement.parentElement).hasClass('vdp-datepicker')) {
                $(event.target.parentElement.parentElement.parentElement).addClass('active');
            } else {
                $(event.target.parentElement).addClass('active');
            }
        });

        $(document).on('focusin', 'textarea', event => {
            if ('component' in event.target.dataset) {
                return;
            }
            $(event.target.parentElement).addClass('active');
        });

        $(document).on('focusout', 'input[type="text"], input[type="email"], input[type="number"], input[type="date"], input[type="password"], input[type="tel"]', event => {
            if ('component' in event.target.dataset) {
                return;
            }
            if (!$(event.target).val()) {

                if ($(event.target.parentElement.parentElement).hasClass('vdp-datepicker')) {
                    $(event.target.parentElement.parentElement.parentElement).removeClass('active');
                } else {
                    $(event.target.parentElement).removeClass('active');
                }

            }
        });

        $(document).on('focusout', 'textarea', event => {
            if ('component' in event.target.dataset) {
                return;
            }
            if (!$(event.target).val()) {
                $(event.target.parentElement).removeClass('active');
            }
        });

        this.updateFloatinglabels();

    },
    updateFloatinglabels() {
        $('input[type="text"], input[type="email"], input[type="number"], input[type="date"], input[type="password"], input[type="tel"]').each(function (index, el) {
            if ($(el).val()) {
                $(el).parent().addClass('active');
            } else {
                $(el).parent().removeClass('active');
            }
        });
    }
};





// WEBPACK FOOTER //
// ./assets/js/libs/Inputs.js